import { styled } from "styled-components";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: 1.5rem;
`;

export const FormBody = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 2rem;
`;

export const FormBodyGridColumn = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 1rem;
  width: 100%;
`;

export const Label = styled.label`
  font-weight: bold;
  color: ${({ theme }) => theme.colors.textBright};
`;

export const RequiredAsterisk = styled.span`
  color: ${({ theme }) => theme.colors.error};
`;

export const ErrorMessage = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.error};
  font-size: 14px;
`;

export const StatusSwitchContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const StatusTag = styled.p<{ isActive: boolean }>`
  color: ${({ isActive, theme }) => (isActive ? theme.colors.green : theme.colors.red)};
  margin: 0;
  border: 1px solid ${({ isActive, theme }) => (isActive ? theme.colors.green : theme.colors.red)};
  border-radius: 20px;
  padding: 4px 8px;
  width: fit-content;
  font-size: 16px;
`;

export const FormFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
`;
